import { render } from "./BoqItemsPreview.vue?vue&type=template&id=29f9afda&scoped=true"
import script from "./BoqItemsPreview.vue?vue&type=script&lang=js"
export * from "./BoqItemsPreview.vue?vue&type=script&lang=js"

import "./BoqItemsPreview.vue?vue&type=style&index=0&id=29f9afda&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f9afda"]])

export default __exports__